import { Badge } from '@vds/badges';
import { TextLink, Button } from '@vds/buttons';
import Star from '@vds/icons/star';
import { Line } from '@vds/lines';
import { Tooltip } from '@vds/tooltips';
import { Body, Micro, Title } from '@vds/typography';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { saveSelectedDeviceDetails, clearSelectedPlanData,  setRetainDatesAndDestinations,saveSelectedDestinations, setUnauthToAuth } from '../../features/selectedData/selectedDataReducer';
import ReviewModal from '../../pages/ITP/ReviewModal';
import { isTab, unauth,unlimitedUltimateRecommendationFFlag } from '../utils/globalConfig';
import { Notification } from '@vds/notifications';
import { dispatchNotifyEvent } from '../utils/tagging'
import PendingOrderModal from './PendingOrderModal';
import { convertStringToElements } from '@vds/html-parsers';
import { savePersistantDestinations,savePersistantDates, clearSelectedPlanFromConfirm } from '../../features/selectedData/persistantDataReducer';
import { openPlanForLine } from '../pageTools/openPlanForLine';
import PropTypes from 'prop-types';


const StyledTextLink = styled(TextLink)`

`

const MainDiv = styled.div`
margin-left: 2%;
margin-bottom: 16px;
display: flex;
width: ${isTab ? '290px' : '348px'};
/* height: 348px; */
padding: 16px 24px;
flex-direction: column;
align-items: flex-start;
gap: 16px;
border-radius: 16px;
border: ${props => props.border || '1px solid var(--vds-elements-text-icons-borders-secondary-ondark, #A7A7A7)'};
background-color: ''
`
const StyledPlanInfoDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-self: stretch;
  align-items: stretch;
  gap: 12px;
  flex: 1;
`
const StyledBottomButtonDiv = styled.div`
  margin-top: auto;
  padding-top: 16px;
  display: flex;
  width: 100%;
  justify-content: stretch;
`
const StyledPlansDiv = styled.div`
display: flex;
justify-content: space-between;

`
const StyledDisplayFlexDiv = styled.div`
display: flex;
`
const StyledRecomFlexDiv = styled.div`
display: flex;
gap: 4px;
`
const StyledDisplayHeader = styled.div`
display: flex;
gap: 16px;
`
const StyledCost = styled.div`
max-width: 35%;
text-align: right;
`
const StyledImageDevice = styled.img`
height: 50px;
`;

const StyledSpaceDiv = styled.div`
margin-left:8px;
`


export default function DeviceDetails({ deviceDetailInfo, flightReviewDetailObject, onlyAirPlane, domesticTooltip, pageType, pendingOrderObject }) {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { failedUpdateCartData } = useSelector(state => state?.selectedReducer);
    const { confirmedPlanData } = useSelector(state => state?.persistantReducer);
    const [showReviewModal, setReviewModal] = useState(false);
    const [reviewPageData, setReviewPageData] = useState();
    const [showPendingOrderModal, setPendingOrderModal] = useState(false);
    const [pendingOrderDeviceInfo, setPendingOrderDeviceInfo] = useState();

    const OnReviewClick = () => {
        setReviewModal(true);
        setReviewPageData(flightReviewDetailObject);
    }

    const openPendingOrderModal = (pendingOrderDevice) => {
        setPendingOrderDeviceInfo(pendingOrderDevice)
        setPendingOrderModal(true);
    }

    useEffect(() => {
        if (deviceDetailInfo?.hasPendingOrder) {
            dispatchNotifyEvent(deviceDetailInfo?.pendingOrderDetail?.description, "99")
        }
    }, [])

    const openEditTripLink = (selectedDeviceDetails) => {
        openPlanForLine(selectedDeviceDetails, { dispatch, navigate });
    }
    // to render planname and plancosts
    const renderPlanDetails = (deviceDetails) => {
        let plandetails = deviceDetails?.currentPlanDetails;
        if (pageType != "confirm" && pageType != "summary") {
            let updatedPlans = confirmedPlanData.filter(plan => plan.mtn === deviceDetails?.mtn);
            if (updatedPlans.length > 0) {
                let [plans] = updatedPlans;
                plandetails = plans?.updatedPlanDetails;
            }
        }
        return plandetails?.map((item, i) => (
            <StyledPlansDiv>
                <StyledDisplayFlexDiv>
                    <Title size="small" primitive="h5">{item?.planName}</Title>
                    {item?.toolTipHeader &&
                        <Tooltip
                            title={item?.toolTipHeader}
                            maxHeight
                            size="small"
                            surface="light">
                            {item?.toolTipText}
                        </Tooltip>}
                    {item?.domesticPlan &&
                        <Tooltip
                            title={domesticTooltip?.toolTipHeader}
                            size="small"
                            maxHeight
                            surface="light">
                            <span dangerouslySetInnerHTML={{ __html: domesticTooltip?.toolTipText }}></span>
                        </Tooltip>}

                </StyledDisplayFlexDiv>
                <StyledCost>
                    {(pageType === 'confirm' && item?.planUpdated === false) ? <Body size="medium" color={'red'}>{deviceDetails?.planFailedLabel}</Body> : <Body size="medium" >{item.planCost}</Body>}
                </StyledCost>
            </StyledPlansDiv>))
    }

    const checkUpdatePlanStatus = () => {
        if (pageType === 'confirm') {
            let statusCheck = [];
            deviceDetailInfo?.currentPlanDetails.map((plan, index) => {
                return plan?.planUpdated ? statusCheck.push(index) : "";
            })
            if (statusCheck?.length === deviceDetailInfo?.currentPlanDetails?.length) {
                return (<Badge
                    fillColor="green">{deviceDetailInfo?.planUpdatedSuccessLabel}
                </Badge>)
            } else if (statusCheck?.length === 0) {
                return (<Badge
                    fillColor="red">{deviceDetailInfo?.planUpdatedErrorLabel}
                </Badge>)
            } else {
                return (<Badge
                    fillColor="orange">{deviceDetailInfo?.planUpdatedPartialLabel}
                </Badge>)
            }
        } else {
            if (confirmedPlanData.some(plan => (plan.mtn === deviceDetailInfo?.mtn))) {
                return (<Badge
                    fillColor="green">{deviceDetailInfo?.planUpdatedSuccessLabel}
                </Badge>)
            } else if (failedUpdateCartData.some(plan => (plan.mtn === deviceDetailInfo?.mtn))) {
                let failedplan = failedUpdateCartData.filter(plan => (plan.mtn === deviceDetailInfo?.mtn))
                if (failedplan[0]?.errorTitle) {
                    return (<><Badge
                        fillColor="red">{failedplan[0]?.errorTitle}
                    </Badge>
                        <Body color='red'>{convertStringToElements(failedplan[0]?.errorMessage)}</Body></>)
                } else {
                    return (<Badge
                        fillColor="red">{deviceDetailInfo?.planUpdatedErrorLabel}
                    </Badge>)
                }

            }
        }
    }

    const changePlanCtaLinkClick = (changePlanCtaUrl,mtnHashCode) =>{
        if(unlimitedUltimateRecommendationFFlag){
            dispatch(saveSelectedDestinations([]));
            dispatch(savePersistantDestinations([]));
            dispatch(savePersistantDates({}));            
            dispatch(setRetainDatesAndDestinations(false));
            const UrlString =  changePlanCtaUrl?.split('##mtnhash##');
            const updatedUrl = UrlString?.[0]?.concat(mtnHashCode);
            window.location.href = updatedUrl;
    }}

    const checkEffectiveDate = () => {
        let updatedPlan = confirmedPlanData.filter(obj => obj.mtn === deviceDetailInfo?.mtn);
        let effectivedate = deviceDetailInfo?.effectiveDate;
        if (updatedPlan.length > 0) {
            let [plans] = updatedPlan;
            effectivedate = plans?.effectiveDate;
        }
        if (effectivedate)
            return <>
                <Line type="secondary"></Line>
                <StyledPlansDiv>
                    <Title>{deviceDetailInfo?.effectiveDateLabel}</Title>
                    <div style={{ maxWidth: '156px', paddingTop: '5px' }}>
                        <Body size="medium">{effectivedate}</Body>
                    </div>
                </StyledPlansDiv></>
    }

    return (
        <React.Fragment>
            {/* device information */}
            {deviceDetailInfo && deviceDetailInfo.travelReady &&
                <MainDiv>
                    {checkUpdatePlanStatus()}
                    {deviceDetailInfo?.hasPendingOrder &&
                        deviceDetailInfo?.pendingOrderDetails?.map((plan, index1) => {
                            return <Notification
                                type="error"
                                children={<>{plan?.description}
                                    &nbsp;
                                    {plan?.isCancellable == "true" && <div><StyledTextLink ariaLabel='PendingOrderReviewDetailLinks' onClick={() => { openPendingOrderModal(plan) }} size="small">{plan?.reviewDetailLabel}</StyledTextLink></div>}</>}
                                hideCloseButton={true} />
                        })
                    }

                    {!deviceDetailInfo?.hasPendingOrder && deviceDetailInfo?.advisory && <Notification
                        type="error"
                        title={deviceDetailInfo?.deviceAdvisory?.message}
                        hideCloseButton={true} />}
                    {/* if only paygo is recommended then dont show recommended text in device page  */}
                    {!(confirmedPlanData.some(plan => (plan.mtn === deviceDetailInfo?.mtn))) && deviceDetailInfo?.planRecommendationInfo?.recommendationAvailable &&
                        <StyledRecomFlexDiv>
                            <Star
                                size="medium"
                                color='red'
                            />

                            <Body size="medium"  bold>
                                <div style={{color:"#EE0000"}}>{deviceDetailInfo?.planRecommendationInfo?.planRecommendationText}
                                <Tooltip
                                    title={deviceDetailInfo?.planRecommendationInfo?.tooltipHeading}
                                    size="small"
                                    maxHeight
                                    surface="light">
                                    {deviceDetailInfo?.planRecommendationInfo?.tooltipText}
                                </Tooltip>
                                </div>
                                {deviceDetailInfo?.planRecommendationInfo?.unlimitedUltimateRecommended && unlimitedUltimateRecommendationFFlag &&
                                    <TextLink onClick={() => { changePlanCtaLinkClick(deviceDetailInfo?.changePlanCtaUrl,deviceDetailInfo?.mtnHashCode) }} size="small" >{deviceDetailInfo?.changePlanCta}</TextLink>}
                            </Body>
                        </StyledRecomFlexDiv>
                    }

                    <StyledDisplayHeader>
                        <StyledImageDevice src={deviceDetailInfo?.deviceImageUrl} alt={deviceDetailInfo?.deviceImageAlt}></StyledImageDevice>
                        <div>
                            {unauth ?
                            <Title bold size="small" primitive="h6">{deviceDetailInfo?.role}</Title>
                            :<Micro size="large" color="#6F7171">{deviceDetailInfo?.role}</Micro>}
                            <Title size="small" bold primitive="h7">{deviceDetailInfo?.deviceNickName}</Title>
                            <Body size="large">{deviceDetailInfo?.formattedMtn}</Body>
                        </div>
                    </StyledDisplayHeader>
                    {deviceDetailInfo?.travelReady &&
                        <>
                            <Line type="secondary"></Line>

                            <StyledPlanInfoDiv>
                                {!(deviceDetailInfo?.onlyCanadaMexicoCovered) && <StyledPlansDiv >
                                    <Body size="small" color="#6F7171">{deviceDetailInfo?.travelPlanLabel}</Body>
                                </StyledPlansDiv>}

                                {!onlyAirPlane && !deviceDetailInfo?.onlyCanadaMexicoCovered && renderPlanDetails(deviceDetailInfo)}

                                {/* only airplane case  */}
                                {onlyAirPlane &&
                                    <StyledDisplayFlexDiv>
                                        <Body size="medium">{deviceDetailInfo.currentPlanName}</Body>
                                        <StyledSpaceDiv></StyledSpaceDiv>
                                        <TextLink onClick={() => { OnReviewClick() }}>{deviceDetailInfo.learnmoreLink}</TextLink>
                                    </StyledDisplayFlexDiv>}

                                {deviceDetailInfo?.lineCoverage && deviceDetailInfo?.canadaMexicoCovered &&
                                    <StyledDisplayFlexDiv>
                                        {deviceDetailInfo?.lineCoverage?.label && <Body size="large" color="#6F7171"  ><span dangerouslySetInnerHTML={{ __html: deviceDetailInfo?.lineCoverage?.label }}></span></Body>}
                                        <Tooltip
                                            ariaLabel={`${deviceDetailInfo?.lineCoverage?.toolTipHeader} more information`}
                                            title={deviceDetailInfo?.lineCoverage?.toolTipHeader}
                                            size="small"
                                            surface="light">
                                            {deviceDetailInfo?.lineCoverage?.toolTipText}
                                        </Tooltip>
                                    </StyledDisplayFlexDiv>}

                                {deviceDetailInfo?.lineCoverage && deviceDetailInfo?.onlyCanadaMexicoCovered &&
                                    <div>
                                        {deviceDetailInfo?.lineCoverage?.onlyCanMex && <Body size="large"  ><span style={{ fontWeight: "bold" }}>{deviceDetailInfo?.lineCoverage?.onlyCanMex?.text}</span><Tooltip
                                            title={deviceDetailInfo?.lineCoverage?.toolTipHeader}
                                            size="small"
                                            surface="light">
                                            {deviceDetailInfo?.lineCoverage?.toolTipText}
                                        </Tooltip></Body>}

                                    </div>}

                                {checkEffectiveDate()}
                                {(pageType !== 'confirm') && !onlyAirPlane && !(deviceDetailInfo?.onlyCanadaMexicoCovered)&&(
                                <StyledBottomButtonDiv>
                                    <Button
                                    style={{ width: '100%' }}
                                    onClick={() => { openEditTripLink(deviceDetailInfo) }}
                                    use="secondary"
                                    disabled={deviceDetailInfo?.hasPendingOrder || deviceDetailInfo?.restrictedDevice}
                                    data-track={deviceDetailInfo?.deviceNickName + '-' + deviceDetailInfo?.travelPlanCta}
                                    aria-label={`${deviceDetailInfo?.travelPlanCta} int'l travel plan for ${deviceDetailInfo?.deviceNickName}`}>{deviceDetailInfo?.travelPlanCta}
                                    </Button>
                                </StyledBottomButtonDiv>
                                )}
                            </StyledPlanInfoDiv>
                        </>}
                </MainDiv>}

            {/* to show reviewdetails modal on click of learnmore link  */}

            {showReviewModal &&
                <ReviewModal
                    setReviewModal={setReviewModal}
                    showReviewModal={showReviewModal}
                    PlanData={reviewPageData} />
            }
            {showPendingOrderModal &&
                <PendingOrderModal
                    setPendingOrderModal={setPendingOrderModal}
                    pendingOrderObject={pendingOrderObject}
                    pendingOrderDeviceInfo={pendingOrderDeviceInfo}
                />
            }
        </React.Fragment>

    )

}
DeviceDetails.propTypes = {
  deviceDetailInfo: PropTypes.shape({
    deviceNickName: PropTypes.string,
    travelPlanCta: PropTypes.string,
    restrictedDevice: PropTypes.bool,
    hasPendingOrder: PropTypes.bool,
    onlyCanadaMexicoCovered: PropTypes.bool,
    lineCoverage: PropTypes.shape({
      label: PropTypes.string,
      toolTipHeader: PropTypes.string,
      toolTipText: PropTypes.string,
      onlyCanMex: PropTypes.shape({
        text: PropTypes.string
      })
    }),
    canadaMexicoCovered: PropTypes.bool,
    currentPlanDetails: PropTypes.array,
    planUpdatedSuccessLabel: PropTypes.string,
    planUpdatedErrorLabel: PropTypes.string,
    planUpdatedPartialLabel: PropTypes.string,
  }),
  flightReviewDetailObject: PropTypes.object,
  onlyAirPlane: PropTypes.bool,
  domesticTooltip: PropTypes.object,
  pageType: PropTypes.string,
  pendingOrderObject: PropTypes.object,
};